import { SendToEnum } from "@schemax-whatsapp/shared-models/common";
import { from } from "rxjs";

export class CompanyDeptRoleCategoryCodeRequest{
    companyCode:string;
    sendTo?:SendToEnum;
    departmentCode?:string;
    role?:string;

    constructor(companyCode:string, sendTo?:SendToEnum,departmentId?:string,role?:string){
        this.companyCode = companyCode;
        this.sendTo = sendTo;
        this.departmentCode = departmentId;
        this.role = role;
    }
}
export class CompanyReq{
    companyId:number;
    constructor(companyId:number){
        this.companyId=companyId;
    }
}

export class companyandModuleandDateReq{
    fromDate:any;
    toDate:any
    companyId?:number;
    moduleId?:number;
   
    constructor(
        fromDate:any,
        toDate:any,
   companyId?:number,
    moduleId?:number,
  
    ){
        this.fromDate=fromDate;
        this.toDate=toDate;
        this.companyId=companyId;
        this.moduleId=moduleId;
      
    }
}


